const STEP_PERCENTAGE = {
    1: 20,
    2: 40,
    3: 60,
    4: 80,
    5: 100,
};

const ProgressBar = ({ currentStep }) => {
    const percentage = STEP_PERCENTAGE[currentStep] || 0;

    return (
        <>
            <div className="kyc-poppins-ui">
                <div className="kyc-progress-header">
                    <span className="kyc-progress-step">Step {currentStep} of 5</span>
                    <span className="kyc-progress-step">{percentage}% Complete</span>
                </div>

                <div className="kyc-progress-track">
                    <div
                        className="kyc-progress-fill"
                        style={{ width: `${percentage}%` }}
                    />
                </div>
            </div>
        </>
    );
};

export default ProgressBar;
